<script>
    import { fade } from "svelte/transition";
    import { portal } from "svelte-portal";
    import { classNames } from "../../utils";
    let cls = "sui-loading";
    export let show = false;
    export let inline = false;
    export let isTransparent = true;
</script>

{#if show}
    {#if inline}
        <div class={`${cls}-wrapper`} transition:fade>
            <div
                class={classNames({
                    [cls]: cls,
                    [$$props.class]: $$props.class,
                })}
            >
                <div class={`${cls}-inner`}>
                    <div />
                    <div />
                    <div />
                </div>
            </div>
        </div>
    {:else}
        <div class={`${cls}-wrapper`} transition:fade use:portal={"body"}>
            <div
                class={classNames({
                    [cls]: cls,
                    [$$props.class]: $$props.class,
                })}
            >
                <div class={`${cls}-inner`}>
                    <div />
                    <div />
                    <div />
                </div>
            </div>
            <div
                class={classNames({
                    [`${cls}-mask`]: true,
                    [`${cls}-mask-transparent`]: isTransparent,
                })}
            />
        </div>
    {/if}
{/if}

<style lang="less">
    @import "./loading.less";
</style>
